module.exports = __webpack_public_path__ + "img/twain.c536e922.jpg";